import type { JSX } from 'react'
import TwilioProviderCard from './TwilioProviderCard.js'
import { InfoCard } from '../../forms/layout/index.js'
import type { TwilioStatusResponse } from '../../../pages/admin/channels-types.js'

export interface TwilioChannelsPanelProps {
  status: TwilioStatusResponse | null
  webhookUrl: string
  onChanged: () => void
}

/**
 * Twilio SMS channel panel: the intro banner plus the Twilio credentials/status
 * card. Sibling to OAuthChannelsPanel; extracted from ChannelsPage's former
 * OAuth-vs-Twilio ternary.
 */
export default function TwilioChannelsPanel(props: TwilioChannelsPanelProps): JSX.Element {
  return (
    <>
      <InfoCard icon="pi pi-check-circle" tone="success" title="SMS Messaging">
        Configure Twilio to send and receive SMS messages. Set up your webhook URL to receive incoming messages.
      </InfoCard>
      <TwilioProviderCard
        status={props.status}
        webhookUrl={props.webhookUrl}
        onChanged={props.onChanged}
      />
    </>
  )
}
